export const connectionEndpoints = {
  development: {
    ssl: false,
    host: 'localhost:3000',
    applicationId: '3LbGvf924hu3B2bETrhKPB49bDNGdcDQCWvUW-8yRVU',
    secret: 'uzcuu9oAhOJ4w30sgCAbN9Yy2TnOuZAhebKRZfeloXU',
  },
  mezzo: {
    ssl: true,
    host: 'mezzo-api.nesscs.com',
    applicationId: '1bW8tZfwYWOlKbDvm-5c5P4O5VKwGoo92B83wwAGGuk',
    secret: 'iNHZw4huB81JHnSO_AE1Y-RymtW1eZIgDUmCLkwnvJM',
    subdomain: 'mezzo',
  },
  localComms: {
    host: 'localhost:3002',
    ssl: false,
  },
  validation: {
    ssl: true,
    host: 'valid-api.nesscs.com',
    applicationId: 'V8EwwdpwoIGEb1GRaW_kDTHivcTKPfPrKvTzb1WtWZM',
    secret: 'uecyO8IrVnygRHJWGjuvlXAQe5sjVr3A2mz8P83fl2k',
    subdomain: 'valid-api',
  },
  smartlink: {
    ssl: true,
    host: 'smartlink-api.nesscs.com',
    applicationId: '9G8WlzKhRKHu60GCg6kyO3hJvJG0b26s1NDxM26YjrQ',
    secret: 'hiORBhvcGt_YLdqBhkh19kF474FtxD4aEbPu7Lz1ee0',
    subdomain: 'smartlink',
  },
}

export const authCredentials = {
  username: 'root',
  password: 'yeeb6ooS',
}

export const defineConnectionInfo = (connectivity, server, endpoints) => {
  if (connectivity === 'cloud') {
    if (endpoints.length) {
      const endpointData = endpoints.find(endpoint => (endpoint.name === server))
      return {
        ssl: true,
        host: endpointData.api_url.slice(8),
        applicationId: endpointData.mezzo_tool_client_id,
        secret: endpointData.mezzo_tool_secret,
      }
    }
    switch (server) {
    case 'mezzo':
      return connectionEndpoints.production
    case 'validation':
      return connectionEndpoints.validation
    case 'smartlink':
      return connectionEndpoints.smartlink
    default:
      return connectionEndpoints.validation
    }
  } else {
    return connectionEndpoints.localComms
  }
}
